import React, { useState, useEffect, useCallback } from "react";
import { smallScreenSize } from "../map/mapProperties";
import Post from "./Post";

const FeedPanel = () => {
  const [lastPost, setLastPost] = useState(null);
  const [initialLoad, setInitialLoad] = useState(true);
  const [loadMore, setLoadMore] = useState(true);
  const [page, setPage] = useState(1);
  const [posts, setPosts] = useState([]);

  const url = `${process.env.REACT_APP_HOST}/api/v1/posts/feed?page=${page}`;

  const loadFeed = useCallback(() => {
    if (loadMore) {
      fetch(url)
        .then((response) => {
          if (response.ok) {
            response.json().then((response) => {
              const nextPage = response.data;
              setPosts((posts) => [...posts, ...nextPage]);
              setPage(page + 1);
              if (nextPage.length >= 2) {
                setLastPost(nextPage[nextPage.length - 2].id);
              }
              if (response.links.next === null) {
                setLoadMore(false);
              }
            });
          } else {
            response.json().then((data) => {
              console.error("Error:", data);
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }, [loadMore, page, url]);

  useEffect(() => {
    if (initialLoad) {
      loadFeed();
      setInitialLoad(false);
    }
  }, [initialLoad, loadFeed]);

  return (
    <aside className="feed">
      <ul className="feed-list">
        {!smallScreenSize && (
          <>
            {posts.map((post) => {
              return (
                <Post
                  description={post.attributes.description}
                  image={post.attributes.image}
                  key={post.id}
                  lastPost={lastPost === post.id}
                  loadFeed={loadFeed}
                  user={post.attributes.user}
                />
              );
            })}
          </>
        )}
      </ul>
    </aside>
  );
};

export default FeedPanel;
